// extracted by mini-css-extract-plugin
export default {"VolumeAdjuster":"VolumeAdjuster_VolumeAdjuster__EFRfI","sound-icon":"VolumeAdjuster_sound-icon__qgRb0","slider":"VolumeAdjuster_slider__0xnbI"};